export default __webpack_public_path__ + "static/media/quehacemos.c6230e1a.webp";